if (!customElements.get('product-carousel')) {
	customElements.define('product-carousel', class ProductCarousel extends HTMLElement {
		constructor() {
			super();
			this.mainCarousel = this.querySelector('.product-carousel-main');	
			this.navCarousel = this.querySelector('.product-carousel-nav');

			if(!this.mainCarousel) return;

			this.flkty = new Flickity(this.mainCarousel, {
				pageDots: this.mainCarousel.querySelectorAll('.product-carousel-main-image').length > 1 ? true : false,
				asNavFor: this.navCarousel ? this.navCarousel : null,
				draggable: false,
				adaptiveHeight: true,
			});

			if(this.navCarousel) {
				this.navFlkty = new Flickity(this.navCarousel, {
					asNavFor: this.mainCarousel,
					contain: true,
					prevNextButtons: true,
					pageDots: false,
					setGallerySize: true,
				});
			}


			this.classList.add('is-loaded');
		}
	});
}


    setTimeout(() => {
		console.log('Initializing PhotoSwipe for product carousel...');
        import('https://unpkg.com/photoswipe@5.3.7/dist/photoswipe-lightbox.esm.js')
            .then(({ default: PhotoSwipeLightbox }) => {
                const lightbox = new PhotoSwipeLightbox({
                    gallery: '.product-carousel-main',
                    children: 'a',
                    pswpModule: () => import('https://unpkg.com/photoswipe@5.3.7/dist/photoswipe.esm.js')
                });

                lightbox.init();
                console.log('PhotoSwipe initialized successfully.');
            })
            .catch(console.error);
    }, 500);